import { render, staticRenderFns } from "./CreateIndexTag.vue?vue&type=template&id=37d24a98&scoped=true&"
import script from "./CreateIndexTag.vue?vue&type=script&lang=js&"
export * from "./CreateIndexTag.vue?vue&type=script&lang=js&"
import style0 from "./CreateIndexTag.vue?vue&type=style&index=0&id=37d24a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d24a98",
  null
  
)

export default component.exports